//
// questionnaireNodeText
//
// Resolve the prompt shown in a questionnaire node's question pill: a node's `txt`
// items resolve in questionnairePrompts; a control-only node with no txt falls back to
// its own qstnId. Never parses the question graph.
//
const questionnaireNodeText = (items, questionId, questionParams, translate) => {
  const parts = (items ?? [])
    .filter((thisItem) => (thisItem.type === 'txt'))
    .map((thisItem) => (thisItem.text
        || (thisItem.id && translate(thisItem.id, 'questionnairePrompts', questionParams))
        || ''))
    .filter((text) => (!!text));

  if (parts.length) return parts.join('\n');

  if (questionId) return translate(questionId, 'questionnairePrompts', questionParams);

  return '';
};

export default questionnaireNodeText;
